import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {WhatWeDoComponent} from './what-we-do.component';
import {ProgramsComponent} from './programs/programs.component';
import {MissionsComponent} from './missions/missions.component';
import {ServicesComponent} from './services/services.component';
import {SundaySchoolComponent} from './sunday-school/sunday-school.component';
import {YouthComponent} from './youth/youth.component';
import {MarriageComponent} from './marriage/marriage.component';
import {HomegroupsComponent} from './homegroups/homegroups.component';
import {CampsComponent} from './camps/camps.component';
import {BibleschoolComponent} from './bibleschool/bibleschool.component';
import {PuppetComponent} from './puppet/puppet.component';
import {PantomimeComponent} from './pantomime/pantomime.component';
import {PlantedChurchesComponent} from './planted-churches/planted-churches.component';
import {MissionariesComponent} from './missionaries/missionaries.component';

const routes: Routes = [
    {path: 'mit-teszunk', component: WhatWeDoComponent},
    {
        path: 'programok',
        children: [
            {path: '', component: ProgramsComponent},
            {path: 'istentiszteletek', component: ServicesComponent},
            {path: 'gyerekfogi', component: SundaySchoolComponent},
            {path: 'ifi', component: YouthComponent},
            {path: 'hazasrandi', component: MarriageComponent},
            {path: 'hazicsoportok', component: HomegroupsComponent},
            {path: 'taborok', component: CampsComponent},
        ]
    },
    {
        path: 'missziok',
        children: [
            {path: '', component: MissionsComponent},
            {path: 'bab', component: PuppetComponent},
            {path: 'pantomim', component: PantomimeComponent},
            {path: 'plantalt', component: PlantedChurchesComponent},
            {path: 'misszionariusok', component: MissionariesComponent},
        ]
    },
    {path: 'bibliaiskola', component: BibleschoolComponent},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class WhatWeDoRoutingModule {}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/what-we-do-routing.module.ts